<style scoped>
    .card-content{
        font-size: 80% !important;
    }
    .card-title{
        font-size: 150% !important;
    }
</style>
<template>
    <div class="row">
        <div class="section">
            <div class="slider">
                <ul class="slides">
                    <li>
                        <img src="../../img/galeriaFotos/048.jpg"> <!-- random image -->
                        <div class="caption center-align">
                            <h3>O Melhor Hotel da Região!</h3>
                            <h5 class="light grey-text text-lighten-3">Venha conferir!</h5>
                        </div>
                    </li>
                    <li>
                        <img src="../../img/galeriaFotos/060.jpg"> <!-- random image -->
                        <div class="caption left-align">
                            <h3>Os Melhores Serviços</h3>
                            <h5 class="light grey-text text-lighten-3">Você só encontra aqui!</h5>
                        </div>
                    </li>
                    <li>
                        <img src="../../img/galeriaFotos/072.jpg"> <!-- random image -->
                        <div class="caption right-align">
                            <h3>Acomodações</h3>
                            <h5 class="light grey-text text-lighten-3">Suítes de Luxo!</h5>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="section">
                <div class="col s6 m3 l3">
                    <div class="card z-depth-2 center blue-grey darken-1 hoverable">
                        <div class="card-content white-text flow-text">
                            <p class="flow-text">Sua Melhor Opção em Resplendor!</p>
                        </div>
                    </div>
                </div>
                <div class="col s6 m3 l3">
                    <div class="card z-depth-2 center hoverable">
                        <div class="card-image">
                            <a href="#!">
                                <img height="100" src="../../img/galeriaFotos/081.jpg">
                            </a>
                        </div>
                        <div class="card-content brown-text">
                            <span class="card-title">Executivas</span>
                            <a class="brown-text" href="#!">Suíte executiva / Noite de núpcias...</a>
                        </div>
                    </div>
                </div>
                <div class="col s6 m3 l3">
                    <div class="card z-depth-2 center hoverable">
                        <div class="card-image">
                            <a href="#/hotel/localizacao">
                                <img height="100" src="../../img/mapa-resplendor.png">
                            </a>
                        </div>
                        <div class="card-content brown-text">
                            <span class="card-title">Localização</span>
                            <a class="brown-text" href="#/hotel/localizacao">Av. Olegário Maciel N.364 B -Centro, Resplendor MG</a>
                        </div>
                    </div>
                </div>
                <div class="col s6 m3 l3">
                    <div class="card z-depth-2 center hoverable">
                        <div class="card-image">
                            <a href="#!">
                                <img height="100" src="../../img/galeriaFotos/008.jpg">
                            </a>
                        </div>
                        <div class="card-content brown-text">
                            <span class="card-title">Serviços</span>
                            <a class="brown-text" href="#/servicos">Café da manhã, Sala de Reunião ...</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    export default {
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-home').addClass('active');

            $('.slider').slider();
            $('.slider').height(330);
            $('.slides').height(300);
        }
    };
</script>




// WEBPACK FOOTER //
// home.vue?bc556034